export default __webpack_public_path__ + "static/media/icon_listView_on.eee3249a.svg";